export const MuiDialog = () => {
    return {
        styleOverrides: {
            root: {
                '& .MuiDialog-paper': {
                    width: '600px',
                    margin: '16px',
                    maxHeight: 'calc(100% - 32px)'
                },
                '& .MuiDialog-paper.MuiDialog-paperFullScreen': {
                    margin: 0,
                    width: '100%',
                    height: '100%',
                    maxWidth: '100%',
                    maxHeight: '100%'
                },
                // First element, but with at least one more element
                '& .MuiDialogContentText-root:first-child:not(:last-child)': {
                    paddingTop: 0,
                    paddingBottom: '8px'
                },
                // Middle elements
                '& .MuiDialogContentText-root:not(:first-child):not(:last-child)': {
                    paddingTop: '8px',
                    paddingBottom: '8px'
                },
                // Last element, but with at least one more element
                '& .MuiDialogContentText-root:last-child:not(:first-child)': {
                    paddingTop: '8px',
                    paddingBottom: 0
                }
            }
        }
    };
};
